<div class="overlay-container">
  <!-- Unsupported Browser -->
  @if (status.reason === reasons.UNSUPPORTED_BROWSER) {
    <div class="overlay-content">
      <p
        class="status-overlay-title"
        [innerHtml]="'go-recorder_unsupported-browsers-warning' | translate: {browser: status.browser}"
      ></p>
      <div class="equipment-check-links">
        <a class="goreact-btn tertiary-btn light"
          [attr.aria-label]="'browser-troubleshooting' | translate"
          [href]="helpUrls.supportedBrowserTroubleshoot"
          target="_blank"
          [innerHtml]="'go-recorder-error_supported-browsers-troubleshooting' | translate">
        </a>
      </div>
    </div>
  }

  <!-- ChromeOS DOODOO Browser -->
  @if (status.reason === reasons.CHROME_OS_DOO_DOO) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder_chrome-os-bug' | translate"></p>
      <div class="equipment-check-links">
        <a class="goreact-btn tertiary-btn light"
          [attr.aria-label]="'browser-troubleshooting' | translate"
          [href]="helpUrls.chromeBugIssues"
          target="_blank"
          [innerHtml]="'video-scenes_chrome-error' | translate">
        </a>
      </div>
    </div>
  }

  <!-- Unsupported iOS Browser -->
  @if (status.reason === reasons.IOS_NON_SUPPORTED_BROWSER) {
    <div class="overlay-content">
      <p class="status-overlay-title">
        {{'common_iOS-browser-unsupported' | translate}}
      </p>
      <div class="equipment-check-links">
        <a class="goreact-btn tertiary-btn light"
          [attr.aria-label]="'browser-troubleshooting' | translate"
          [href]="helpUrls.supportedBrowserTroubleshoot"
          target="_blank" [innerHtml]="'go-recorder-error_supported-browsers-troubleshooting' | translate">
        </a>
      </div>
      <div class="btn-container">
        <button
          type="button"
          class="goreact-btn secondary-btn no-audio-continue"
          [attr.aria-label]="'go-recorder-proceed_anyway' | translate"
          (click)="status.action()"
          [innerHtml]="'go-recorder-error_continue-with-no-audio' | translate">
        </button>
      </div>
    </div>
  }

  <!-- Microphone No Audio -->
  @if (status.reason === reasons.MICROPHONE_NO_AUDIO) {
    <div class="overlay-content">
      <p class="status-overlay-title" translate="go-recorder_equipment-error-mic"></p>
      <div class="btn-container">
        <button
          type="button"
          class="goreact-btn primary-btn try-again"
          [attr.aria-label]="'go-recorder-error_try-again' | translate"
          (click)="status.action()"
          [innerHtml]="'go-recorder-error_try-again' | translate">
        </button>
      </div>
      <div class="btn-container">
        <button
          type="button"
          class="goreact-btn secondary-btn no-audio-continue"
          [attr.aria-label]="'go-recorder-error_continue-with-no-audio' | translate"
          (click)="this.continueWithoutAudio()"
          [innerHtml]="'go-recorder-error_continue-with-no-audio' | translate">
        </button>
      </div>
      <div class="equipment-check-links">
        <a class="goreact-btn tertiary-btn light"
          [attr.aria-label]="'go-recorder-error_microphone-troubleshooting' | translate"
          [href]="helpUrls.microphoneTroubleshoot"
          target="_blank"
          [innerHtml]="'go-recorder-error_microphone-troubleshooting' | translate">
        </a>
      </div>
    </div>
  }

  <!-- Camera No Motion -->
  @if (status.reason === reasons.CAMERA_NO_MOTION) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder_equipment-error-camera' | translate"></p>
      <div class="btn-container">
        <button
          type="button"
          class="goreact-btn primary-btn try-again"
          [attr.aria-label]="'go-recorder-error_try-again' | translate"
          (click)="status.action()"
          [innerHtml]="'go-recorder-error_try-again' | translate">
        </button>
      </div>
      <div class="equipment-check-links">
        <a class="goreact-btn tertiary-btn light"
          [attr.aria-label]="'go-recorder-error_camera-troubleshooting' | translate"
          [href]="helpUrls.cameraTroubleshoot"
          target="_blank"
          [innerHtml]="'go-recorder-error_camera-troubleshooting' | translate">
        </a>
      </div>
    </div>
  }

  <!-- Camera No Permission -->
  @if (status.reason === reasons.CAMERA_NO_PERMISSION || status.reason === reasons.CAMERA_NOT_FOUND) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder_equipment-error-permission' | translate"></p>
      <div class="equipment-check-links">
        <a class="goreact-btn link-btn light"
          [attr.aria-label]="'common_get-help' | translate"
          [href]="helpUrls.videoTroubleshoot"
          target="_blank"
          [innerHtml]="'common_get-help' | translate">
        </a>
      </div>
    </div>
  }

  <!-- Camera In Use -->
  @if (status.reason === reasons.CAMERA_IN_USE) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder_equipment-error-in-use' | translate"></p>
      <div class="equipment-check-links">
        <a class="goreact-btn link-btn light"
          [attr.aria-label]="'common_get-help' | translate"
          [href]="helpUrls.cameraTroubleshoot"
          target="_blank"
          [innerHtml]="'common_get-help' | translate">
        </a>
      </div>
    </div>
  }

  <!-- OpenTok Connection Failed -->
  @if (status.reason === reasons.OPENTOK_CONNECTION_FAILED) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHTML]="'go-recorder_equipment-error-server' | translate"></p>
      <div class="btn-container">
        <button
          type="button"
          class="goreact-btn primary-btn close-error"
          [attr.aria-label]="'common_close' | translate"
          (click)="status.action()"
          [innerHtml]="'go-recorder-error_close' | translate">
        </button>
      </div>
      <div class="equipment-check-links">
        <a class="goreact-btn tertiary-btn light"
          [attr.aria-label]="'go-recorder-error_troubleshooting' | translate"
          [href]="helpUrls.networkTroubleshoot"
          target="_blank"
          [innerHtml]="'go-recorder-error_troubleshooting' | translate">
        </a>
      </div>
    </div>
  }

  <!-- OpenTok Connecting -->
  @if (status.reason === reasons.OPENTOK_CONNECTING) {
    <div class="overlay-content">
      <p
        class="status-overlay-title"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        [innerHtml]="'go-recorder-status_connecting' | translate">
      </p>
    </div>
  }

  <!-- OpenTok Reconnecting -->
  @if (status.reason === reasons.OPENTOK_RECONNECTING) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder-status_reconnecting' | translate"></p>
    </div>
  }

  <!-- OpenTok Poor Connection -->
  @if (status.reason === reasons.OPENTOK_POOR_CONNECTION) {
    <div class="overlay-content">
      <span class="toast-icon">
        <i class="ficon-app-warning-circle-outline"></i>
      </span>
      <p class="status-overlay-title" [innerHtml]="'go-recorder-status_poor-connection' | translate"></p>
    </div>
  }

  @if (status.reason === reasons.OPENTOK_POOR_CONNECTION) {
    <div class="network-content">
      <network-indicator></network-indicator>
    </div>
  }

  <!-- OpenTok Network Disconnected -->
  @if (status.reason === reasons.OPENTOK_NETWORK_DISCONNECTED) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder-status_network-disconnected' | translate"></p>
    </div>
  }

  <!-- OpenTok Network Failed -->
  @if (status.reason === reasons.OPENTOK_NETWORK_FAILED) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder-status_network-failed' | translate"></p>
    </div>
  }

  @if (status.reason === reasons.SCREEN_SHARE_PREPARING) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder-status_preparing_screen_share' | translate"></p>
    </div>
  }

  @if (status.reason === reasons.RESOLUTION_UPDATING) {
    <div class="overlay-content">
      <i class="ficon-spinner ficon-spin"></i>
    </div>
  }

  @if (status.reason === reasons.RESTARTING_SESSION) {
    <div class="overlay-content">
      <p class="status-overlay-title" [innerHtml]="'go-recorder-status_restarting' | translate"></p>
    </div>
  }
</div>
